import { memo as Memo, useMemo } from 'react';

//* Components
import CustomLottie from '../../CustomLottie';

//* JSONs
import animJSON1 from './AboutAnimPunctulaity.json';
import animJSON2 from './AboutAnimTransparency.json';
import animJSON3 from './AboutAnimOriginality.json';
import animJSON4 from './AboutAnimForm.json';
import animJSON5 from './AboutAnimTeamWork.json';

//* Styles
import AboutAnimCharsStyle from './style';

const AboutAnim = Memo((props) => {
	const animDatas = useMemo(
		() => ({
			animJSON1,
			animJSON2,
			animJSON3,
			animJSON4,
			animJSON5,
		}),
		[]
	);

	const animData = useMemo(() => {
		const type = props.type || 1;
		return animDatas[`animJSON${type}`];
	}, [props.type]);

	return (
		<AboutAnimCharsStyle className={'AboutAnim'}>
			<CustomLottie
				animData={animData}
				isStopped={!props.play}
			/>
		</AboutAnimCharsStyle>
	);
});

export default AboutAnim;
